/* eslint-disable react/react-in-jsx-scope */
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import Main from './components/blanks/Main';
import Root from './containers/Root';

if (process.env.REACT_APP_SENTRY_DSL) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSL,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ['https://ventaudit.ciat.net.ua'],
    // Session Replay
    // This sets the sample rate at 10%. You may want to change it to
    // 100% while in development and then sample at a lower rate in production.
    replaysSessionSampleRate: 0.1,
    // If you're not already sampling the entire session, change the sample
    // rate to 100% when sampling sessions where errors occur.  });
    replaysOnErrorSampleRate: 1.0,
  });
}
const container = document.getElementById('root');
if (container) {
  const root = ReactDOM.createRoot(container);
  root.render(
    <Main>
      <Root />
    </Main>,
  );
} else {
  console.error("Контейнер с id='root' не найден в DOM.");
}
